import moment from 'moment'
import React, { FunctionComponent } from 'react'

import { Person } from '../../../../App/store/features/person/IPerson'
import { IAppointment, TOpenEventDetails } from '../../../types'

import { DeleteAppointment } from './DeleteAppointment'
import { UpdateDetails } from './UpdateDetails'
import { UpdateNotes } from './UpdateNotes'
import { UpdatePrint } from './UpdatePrint'

interface IProps {
  appointmentDetails: IAppointment
  openEventDetails: TOpenEventDetails
  personList: Person[]
}

export const UpdateAppointment: FunctionComponent<IProps> = ({
  appointmentDetails,
  personList,
  openEventDetails,
}) => {
  const appointmentDateKey: string = moment(appointmentDetails.startsAt).format(
    'YYYY-MM-DD',
  )
  switch (openEventDetails.type) {
    case 'update_appointment_details':
      return (
        <UpdateDetails
          appointmentDetails={appointmentDetails}
          personList={personList}
        />
      )

    case 'update_appointment_notes':
      return (
        <UpdateNotes
          appointmentDateKey={appointmentDateKey}
          appointmentNotes={appointmentDetails.appointmentNotes}
          repeatDetails={appointmentDetails.repeatDetails}
          appointmentUuid={appointmentDetails.uuid}
        />
      )
    case 'update_appointment_print':
      return <UpdatePrint />
    case 'update_appointment_delete':
      return (
        <DeleteAppointment
          appointmentDateKey={appointmentDateKey}
          repeatDetails={appointmentDetails.repeatDetails}
          appointmentUuid={appointmentDetails.uuid}
        />
      )
    default:
      return (
        <UpdateDetails
          appointmentDetails={appointmentDetails}
          personList={personList}
        />
      )
  }
}
